/* Product card: rotating 3D model on hover.
 * Used by snippets/card-product-media.liquid when the product's featured
 * media is a 3D model. At rest the card shows the model's preview image;
 * on hover (mouse only) the model loads via Shopify's own model-viewer
 * library and slowly auto-rotates. Clicking still opens the product.
 */
(function () {
  if (customElements.get('hdt-card-model')) return;

  var style = document.createElement('style');
  style.textContent =
    '.hdt-card-model{position:absolute;inset:0;z-index:2;opacity:0;pointer-events:none;transition:opacity .35s ease}' +
    '.hdt-card-model model-viewer{display:block;width:100%;height:100%;background:#f9f9f7}' +
    '.hdt-card-model.is-active{opacity:1}' +
    '@media (hover:none){.hdt-card-model{display:none}}';
  document.head.appendChild(style);

  // Shopify hosts the <model-viewer> element library itself (same build the
  // product page uses). Loaded once, on the first hover.
  var LIB_URL = 'https://cdn.shopify.com/shopifycloud/model-viewer/v1.12/model-viewer.js';
  var libReady = null;
  function loadLib() {
    if (libReady) return libReady;
    libReady = new Promise(function (resolve) {
      if (!customElements.get('model-viewer')) {
        var s = document.createElement('script');
        s.src = LIB_URL;
        s.async = true;
        document.head.appendChild(s);
      }
      customElements.whenDefined('model-viewer').then(resolve);
    });
    return libReady;
  }

  class CardModel extends HTMLElement {
    connectedCallback() {
      var host = this.closest('.hdt-card-product__media') || this.parentElement;
      var self = this;
      host.addEventListener('mouseenter', function () { self.start(); });
      host.addEventListener('mouseleave', function () { self.stop(); });
    }
    start() {
      var self = this;
      this.hovering = true;
      loadLib().then(function () {
        if (!self.hovering) return;
        if (!self.viewer) {
          var mv = document.createElement('model-viewer');
          mv.setAttribute('src', self.getAttribute('src'));
          mv.setAttribute('alt', self.getAttribute('alt') || '');
          mv.setAttribute('loading', 'eager');
          mv.setAttribute('auto-rotate', '');
          mv.setAttribute('auto-rotate-delay', '0');
          mv.setAttribute('rotation-per-second', '30deg');
          mv.setAttribute('interaction-prompt', 'none');
          mv.setAttribute('camera-orbit', '35deg 76deg 105%');
          mv.setAttribute('field-of-view', '28deg');
          mv.setAttribute('shadow-intensity', '1');
          mv.setAttribute('shadow-softness', '0.8');
          mv.addEventListener('load', function () {
            if (self.hovering) self.classList.add('is-active');
          });
          self.appendChild(mv);
          self.viewer = mv;
        } else {
          self.viewer.autoRotate = true;
          self.classList.add('is-active');
        }
      });
    }
    stop() {
      this.hovering = false;
      this.classList.remove('is-active');
      if (this.viewer) this.viewer.autoRotate = false;
    }
  }
  customElements.define('hdt-card-model', CardModel);
})();
